import { Injectable } from "@angular/core";
import { ProductRepository } from "../../../../core/repositories";
import { BaseResponse, Product } from "../../../../core/domain/models";
import { catchError, map, mergeMap, Observable, reduce } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ProductApiUrlsEnum } from "./product-api-urls.enum";
import { ProductWebEntity } from "./product.web-entity";
import { ProductWebRepositoryMapper } from "./product.web-repository-mapper";
import { injectEnvironment } from "master-locations-library/master-locations-library/src/lib/core/environments/environment.token";

@Injectable()
export class ProductWebRepository extends ProductRepository {

  environment = injectEnvironment()

  constructor(private httpClient: HttpClient) {
    super();
  }

  getProducts(): Observable<Product[]> {
    const productsMapper = new ProductWebRepositoryMapper();
    return this.httpClient
      .get<BaseResponse<ProductWebEntity[]>>(`${this.environment.url}${ProductApiUrlsEnum.GetProducts}`)
      .pipe(mergeMap((response: BaseResponse<ProductWebEntity[]>) => (response.result)),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(productsMapper.mapFrom))
      .pipe(reduce((items: Product[], item: Product) => [...items, item], []));
  }
}
